import React from 'react';
import { Layer, ProjectState } from "../../shared";
import { useCurrentFrame } from 'remotion';

type Props = { 
    layer: Layer,
    project: ProjectState,
};

function TextLayer({ layer }: Props) {
    const { blendMode, opacity, visible } = layer;
    const frame = useCurrentFrame();
    const isVisible = visible && frame >= layer.startFrame && frame <= layer.endFrame;
    const { x, y } = layer.position;
    const { width, height } = layer.dimensions;
    const {
        value,
        fontSize,
        fontWeight,
        fontFamily,
        lineHeight,
        letterSpacing,
        color,
        backgroundColor
    } = layer.text!;
    return (
        <div 
            style={{ 
                position: 'absolute',
                top: y || 0,
                left: x || 0,
                width,
                height,
                opacity: isVisible ? opacity : 0,
                mixBlendMode: blendMode,
                backgroundColor,
                color,
                fontSize,
                fontWeight,
                fontFamily,
                lineHeight,
                letterSpacing
            }}>
            {value}
        </div>
    )
}


export default TextLayer;
